module.exports = __webpack_public_path__ + "img/stock_shopbag_list.b36013d8.png";